import {
  useFollowUpDateGroupModal, useSaveClientTagMutation, useSaveDisqualifiedReasonMutation,
  useSaveExpectedCloseDateMutation,
  useSaveStatusMutation, useTagsQuery
} from '../../../../../shared';
import { enqueueSnackbar } from 'notistack';
import { useState } from 'react';
import { Client } from '../../../../../shared/api/use-client-subscription';
import moment from 'moment';
import _ from 'lodash';
import { DisqualifiedReasonDto, StatusDto } from '@coverright/data-access/types/enrollment';

interface ExpiredFollowUpDateModalCallback {
  followUpDate?: string | null,
  expectedCloseDate?: string | null,
  disqualifiedReason?: DisqualifiedReasonDto,
  status?: StatusDto,
  tagAsMissed?: boolean
}

export const useSaveNextContactDateDialog = (client: Partial<Client>) => {
  const [saveStatus] = useSaveStatusMutation({
    onCompleted: () => {
      enqueueSnackbar('Next contact date changed!', {variant: "success"});
    }
  });
  const [saveExpectedCloseDate] = useSaveExpectedCloseDateMutation();
  const [saveDisqualifiedReason] = useSaveDisqualifiedReasonMutation();
  const [saveClientTags] = useSaveClientTagMutation();
  const changeFollowUpDateForGroup = useFollowUpDateGroupModal();
  const {data} = useTagsQuery()
  const [loading, setLoading] = useState(false);
  const tags = data?.tags ?? [];

  const save = async (data: ExpiredFollowUpDateModalCallback) => {
    setLoading(true);

    try {
      const status = data.status ? data.status : data.followUpDate ? StatusDto.FollowUp : (client.status || StatusDto.FollowUp)
      const followUpDate = data.followUpDate ? moment(data.followUpDate).format('YYYY-MM-DD') : undefined;

      await saveStatus({
        variables: {
          id: client?.id,
          followUpDate,
          agentId: client?.agent?.id,
          status,
        }
      });

      const expectedCloseDateStr = data.expectedCloseDate ? moment(data.expectedCloseDate).format('YYYY-MM-DD') : undefined;

      if (data.expectedCloseDate) {
        await saveExpectedCloseDate({
          variables: {
            id: client?.id,
            expectedCloseDate: expectedCloseDateStr,
          }
        })
      }

      if (data.status === StatusDto.Disqualified && data.disqualifiedReason) {
        await saveDisqualifiedReason({
          variables: {
            id: client?.id,
            disqualifiedReason: data.disqualifiedReason,
          }
        })
      }

      if (data.tagAsMissed) {
        const tag = tags.find((tag) => tag.name === 'Missed Appt –CSR Follow Up')
        if (tag) {
          await saveClientTags({
            variables: {
              input: {
                clientId: client?.id,
                tags: _.uniqBy([...(client.tags?.map(t => ({id: t.tag.id, expiresAt: t.expiresAt})) || []), {id: tag.id}], 'id')
              }
            }
          });
        }
      }

      if (followUpDate) {
        await changeFollowUpDateForGroup(client.id, followUpDate, status, undefined, expectedCloseDateStr);
      }
    } finally {
      setLoading(false)
    }

  }

  return {
    save, loading
  }
}
